/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha30 = props => (
<svg version={1.0} width="1em" height="1em" viewBox="0 0 300 300" {...props}>
  <g transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
     stroke="none">
    <path d="M2353 5643 c-27 -30 -38 -116 -57 -463 -17 -303 -29 -413 -43 -383
-22 50 -232 66 -234 18 -1 -14 -9 -69 -17 -122 l-16 -96 72 16 c94 22 1790 22
1884 0 l72 -16 -16 96 c-8 53 -16 108 -17 122 -2 48 -212 32 -234 -18 -14 -30
-26 80 -43 383 -19 347 -30 433 -57 463 -51 57 -1243 57 -1294 0z"/>
    <path d="M2199 4561 c-219 -39 -421 -197 -521 -408 l-58 -123 0 -1030 0 -1030
58 -123 c76 -160 193 -275 359 -354 l133 -63 830 0 830 0 133 63 c166 79 283
194 359 354 l58 123 0 1030 0 1030 -58 123 c-76 160 -193 275 -359 354 l-133
63 -770 3 c-423 2 -811 -4 -861 -12z m1693 -325 c88 -48 182 -162 207 -250 28
-103 28 -1869 0 -1972 -48 -172 -190 -272 -411 -289 l-148 -11 0 -73 c0 -121
0 -121 -530 -121 -530 0 -530 0 -530 121 l0 73 -157 11 c-230 16 -373 114
-422 289 -28 103 -28 1869 0 1972 36 128 155 242 289 276 134 34 1635 11 1702
-26z"/>
    <path d="M2160 4178 c-27 -11 -71 -40 -97 -64 -105 -98 -103 -81 -103 -1120
l0 -968 45 -68 c105 -155 390 -223 495 -118 62 62 962 62 1015 0 91 -106 376
-36 480 118 l45 68 0 974 0 974 -45 66 c-107 157 -61 150 -971 154 -514 3
-832 -3 -864 -16z"/>
    <path d="M2540 1700 l0 -100 105 -1 c241 -2 593 -3 700 -1 l115 2 0 100 0 100
-460 0 -460 0 0 -100z"/>
    <path d="M2002 1307 c8 -53 16 -108 17 -122 2 -48 212 -32 234 18 14 30 26
-80 43 -383 31 -560 -54 -500 704 -500 758 0 673 -60 704 500 17 303 29 413
43 383 22 -50 232 -66 234 -18 1 14 9 69 17 122 l16 96 -72 -16 c-94 -22
-1790 -22 -1884 0 l-72 16 16 -96z"/>
  </g>
</svg>
);
export default extendIcon(Deha30);
